import React from "react";

const BS5_GridLarge = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridLarge Component</h2>
      <p>This is the BS5_GridLarge component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridLarge;
